// // // // import React from "react";
// // // // import phoneImage from "../assets/newScreen.png";
// // // // import googleLogo from "../assets/googlelogo.png";
// // // // import { FaApple } from "react-icons/fa";

// // // // const GetApp = () => {
// // // //   return (
// // // //   <section className="flex flex-col md:flex-row items-center justify-center px-6 md:px-16 gap-14 lg:gap-24 
// // // // py-12 md:py-20 mx-auto bg-gradient-to-b from-[#FFFFFF] to-[#EAE7FF]">

    
// // // //     {/* Phone Image (left on desktop) */}
// // // //     <div className="md:w-1/2 flex justify-center md:justify-end mb-6 md:mb-0">
// // // //       <img
// // // //         src={phoneImage}
// // // //         alt="Jurident Mobile App"
// // // //         className="w-[140px] md:w-[200px] lg:w-[240px] hover:scale-105 duration-300"
// // // //       />
// // // //     </div>

// // // //     {/* Text + Buttons (right on desktop) */}
// // // //     <div className="md:w-1/2 text-center md:text-left md:ml-0">
// // // //       {/* Heading */}
// // // //       <h2 className="text-2xl sm:text-3xl md:text-[50px] leading-tight md:leading-[65px] font-semibold text-[#141414] font-['Work_Sans']">
// // // //         Your Legal Partner, <br /> Anytime, Anywhere.
// // // //       </h2>

// // // //       {/* Subheading */}
// // // //       <p className="text-lg sm:text-xl md:text-[28px] md:leading-[38px] mt-4 font-medium text-[#141414] font-['Work_Sans'] capitalize">
// // // //         Download Jurident Now!
// // // //       </p>

// // // //       {/* Store Buttons */}
// // // //       <div className="flex justify-center md:justify-start gap-4 md:gap-6 mt-6 flex-wrap">
// // // //         {/* App Store */}
// // // //         <a
// // // //           href="https://apps.apple.com/in/app/jurident/id6475091173"
// // // //           target="_blank"
// // // //           rel="noopener noreferrer"
// // // //           className="inline-flex items-center gap-3 px-5 py-2.5 bg-white rounded-[18px] shadow-md hover:shadow-lg transition-all"
// // // //         >
// // // //           <FaApple className="text-black w-6 h-6 md:w-[30px] md:h-[32px]" />
// // // //           <span className="text-sm md:text-[22px] font-medium font-['Poppins'] text-black">
// // // //             App Store
// // // //           </span>
// // // //         </a>

// // // //         {/* Play Store */}
// // // //         <a
// // // //           href="https://play.google.com/store/apps/details?id=com.jurident.valsco&pli=1"
// // // //           target="_blank"
// // // //           rel="noopener noreferrer"
// // // //           className="inline-flex items-center gap-3 px-5 py-2.5 bg-white rounded-[18px] shadow-md hover:shadow-lg transition-all"
// // // //         >
// // // //           <img
// // // //             src={googleLogo}
// // // //             alt="Google Play Logo"
// // // //             className="w-6 h-6 md:w-[30px] md:h-[32px]"
// // // //           />
// // // //           <span className="text-sm md:text-[22px] font-medium font-['Poppins'] text-black">
// // // //             Play Store
// // // //           </span>
// // // //         </a>
// // // //       </div>
// // // //     </div>
// // // //   </section>
// // // // );

// // // // };

// // // // export default GetApp;
















// // // import React from "react";
// // // import { motion } from "framer-motion";
// // // import phoneImage from "../assets/newScreen.png";
// // // import googleLogo from "../assets/googlelogo.png";
// // // import { FaApple } from "react-icons/fa";

// // // const GetApp = () => {
// // //   return (
// // //     <section className="relative overflow-hidden bg-gradient-to-b from-[#FFFFFF] via-[#F3F1FF] to-[#E6E3FF]">
      
// // //       {/* Ambient luxury glow */}
// // //       <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-purple-300/30 rounded-full blur-[120px]" />
// // //       <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-indigo-300/30 rounded-full blur-[120px]" />

// // //       <div className="relative z-10 flex flex-col md:flex-row items-center justify-center px-6 md:px-16 gap-14 lg:gap-24 py-14 md:py-24 mx-auto">

// // //         {/* Phone Image */}
// // //         <motion.div
// // //           initial={{ opacity: 0, y: 40 }}
// // //           whileInView={{ opacity: 1, y: 0 }}
// // //           transition={{ duration: 0.8, ease: "easeOut" }}
// // //           viewport={{ once: true }}
// // //           className="md:w-1/2 flex justify-center md:justify-end"
// // //         >
// // //           <motion.img
// // //             src={phoneImage}
// // //             alt="Jurident Mobile App"
// // //             className="w-[150px] md:w-[210px] lg:w-[260px] drop-shadow-[0_40px_80px_rgba(0,0,0,0.25)]"
// // //             animate={{ y: [0, -10, 0] }}
// // //             transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
// // //           />
// // //         </motion.div>

// // //         {/* Text + Buttons */}
// // //         <motion.div
// // //           initial={{ opacity: 0, y: 40 }}
// // //           whileInView={{ opacity: 1, y: 0 }}
// // //           transition={{ duration: 0.9, ease: "easeOut", delay: 0.1 }}
// // //           viewport={{ once: true }}
// // //           className="md:w-1/2 text-center md:text-left"
// // //         >
// // //           {/* Heading */}
// // //           <h2 className="text-2xl sm:text-3xl md:text-[52px] leading-tight md:leading-[68px] font-semibold text-[#141414] font-['Work_Sans']">
// // //             Your Legal Partner,
// // //             <br />
// // //             <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#5B4BFF] to-[#7C6BFF]">
// // //               Anytime, Anywhere.
// // //             </span>
// // //           </h2>

// // //           {/* Subheading */}
// // //           <p className="text-lg sm:text-xl md:text-[28px] md:leading-[38px] mt-5 font-medium text-[#2A2A2A] font-['Work_Sans']">
// // //             Experience the future of legal practice.
// // //             <br />
// // //             Secure. Smart. Always with you.
// // //           </p>

// // //           {/* Store Buttons */}
// // //           <div className="flex justify-center md:justify-start gap-4 md:gap-6 mt-10 flex-wrap">

// // //             {/* App Store */}
// // //             <motion.a
// // //               whileHover={{ scale: 1.06 }}
// // //               whileTap={{ scale: 0.97 }}
// // //               href="https://apps.apple.com/in/app/jurident/id6475091173"
// // //               target="_blank"
// // //               rel="noopener noreferrer"
// // //               className="inline-flex items-center gap-3 px-6 py-3 bg-white/80 backdrop-blur-md rounded-[22px] shadow-[0_20px_40px_rgba(0,0,0,0.15)] hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)] transition-all"
// // //             >
// // //               <FaApple className="text-black w-7 h-7 md:w-[32px] md:h-[34px]" />
// // //               <span className="text-sm md:text-[22px] font-medium font-['Poppins'] text-black">
// // //                 App Store
// // //               </span>
// // //             </motion.a>

// // //             {/* Play Store */}
// // //             <motion.a
// // //               whileHover={{ scale: 1.06 }}
// // //               whileTap={{ scale: 0.97 }}
// // //               href="https://play.google.com/store/apps/details?id=com.jurident.valsco&pli=1"
// // //               target="_blank"
// // //               rel="noopener noreferrer"
// // //               className="inline-flex items-center gap-3 px-6 py-3 bg-white/80 backdrop-blur-md rounded-[22px] shadow-[0_20px_40px_rgba(0,0,0,0.15)] hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)] transition-all"
// // //             >
// // //               <img
// // //                 src={googleLogo}
// // //                 alt="Google Play Logo"
// // //                 className="w-7 h-7 md:w-[32px] md:h-[34px]"
// // //               />
// // //               <span className="text-sm md:text-[22px] font-medium font-['Poppins'] text-black">
// // //                 Play Store
// // //               </span>
// // //             </motion.a>

// // //           </div>
// // //         </motion.div>

// // //       </div>
// // //     </section>
// // //   );
// // // };

// // // export default GetApp;
























// // import React from "react";
// // import { motion } from "framer-motion";
// // import phoneImage from "../assets/newScreen.png";
// // import googleLogo from "../assets/googlelogo.png";
// // import { FaApple } from "react-icons/fa";

// // const GetApp = () => {
// //   return (
// //     <section className="relative overflow-hidden bg-[#0A0A0F]">

// //       {/* ───────── Luxury Ambient Layers ───────── */}
// //       <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(180,150,90,0.25),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(120,100,255,0.25),transparent_45%),radial-gradient(circle_at_50%_80%,rgba(255,255,255,0.08),transparent_50%)]" />
      
// //       <div className="absolute inset-0 backdrop-blur-[2px]" />

// //       {/* ───────── Content Wrapper ───────── */}
// //       <div className="relative z-10 flex flex-col md:flex-row items-center justify-center px-6 md:px-16 gap-16 lg:gap-28 py-20 md:py-32 mx-auto max-w-7xl">

// //         {/* ───────── Phone Section ───────── */}
// //         <motion.div
// //           initial={{ opacity: 0, y: 80 }}
// //           whileInView={{ opacity: 1, y: 0 }}
// //           transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
// //           viewport={{ once: true }}
// //           className="md:w-1/2 flex justify-center md:justify-end relative"
// //         >
// //           {/* Gold halo */}
// //           <div className="absolute -inset-10 rounded-full bg-gradient-to-tr from-[#C9A24D]/30 via-transparent to-[#6E63FF]/30 blur-[120px]" />

// //           <motion.img
// //             src={phoneImage}
// //             alt="Jurident Mobile App"
// //             className="relative w-[160px] md:w-[230px] lg:w-[280px] drop-shadow-[0_60px_120px_rgba(0,0,0,0.6)]"
// //             animate={{ y: [0, -14, 0] }}
// //             transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }}
// //           />
// //         </motion.div>

// //         {/* ───────── Text + CTA ───────── */}
// //         <motion.div
// //           initial={{ opacity: 0, y: 60 }}
// //           whileInView={{ opacity: 1, y: 0 }}
// //           transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
// //           viewport={{ once: true }}
// //           className="md:w-1/2 text-center md:text-left"
// //         >
// //           {/* Eyebrow */}
// //           <p className="text-sm tracking-[0.35em] uppercase text-[#C9A24D] mb-6">
// //             Jurident Mobile Experience
// //           </p>

// //           {/* Heading */}
// //           <h2 className="text-3xl sm:text-4xl md:text-[54px] leading-tight md:leading-[70px] font-semibold text-white font-['Work_Sans']">
// //             Your Legal Partner,
// //             <br />
// //             <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#E6C77B] via-[#F5E3A1] to-[#B58B2A]">
// //               Anytime. Anywhere.
// //             </span>
// //           </h2>

// //           {/* Subheading */}
// //           <p className="mt-6 text-lg md:text-[26px] leading-relaxed text-gray-300 font-medium max-w-xl">
// //             Designed for modern legal professionals who demand
// //             <span className="text-white font-semibold"> precision</span>,
// //             <span className="text-white font-semibold"> security</span>, and
// //             <span className="text-white font-semibold"> elegance</span>.
// //           </p>

// //           {/* CTA Buttons */}
// //           <div className="flex justify-center md:justify-start gap-5 mt-12 flex-wrap">

// //             {/* App Store */}
// //             <motion.a
// //               whileHover={{ scale: 1.07 }}
// //               whileTap={{ scale: 0.96 }}
// //               href="https://apps.apple.com/in/app/jurident/id6475091173"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="group relative inline-flex items-center gap-3 px-7 py-3 rounded-[22px] bg-white/10 backdrop-blur-xl border border-white/20 shadow-[0_25px_60px_rgba(0,0,0,0.5)] hover:border-[#E6C77B]/50 transition-all"
// //             >
// //               <FaApple className="text-white w-7 h-7" />
// //               <span className="text-[20px] font-medium font-['Poppins'] text-white">
// //                 App Store
// //               </span>

// //               {/* Glow */}
// //               <span className="absolute inset-0 rounded-[22px] bg-gradient-to-r from-[#E6C77B]/30 to-[#6E63FF]/30 opacity-0 group-hover:opacity-100 blur-xl transition" />
// //             </motion.a>

// //             {/* Play Store */}
// //             <motion.a
// //               whileHover={{ scale: 1.07 }}
// //               whileTap={{ scale: 0.96 }}
// //               href="https://play.google.com/store/apps/details?id=com.jurident.valsco&pli=1"
// //               target="_blank"
// //               rel="noopener noreferrer"
// //               className="group relative inline-flex items-center gap-3 px-7 py-3 rounded-[22px] bg-white/10 backdrop-blur-xl border border-white/20 shadow-[0_25px_60px_rgba(0,0,0,0.5)] hover:border-[#E6C77B]/50 transition-all"
// //             >
// //               <img src={googleLogo} alt="Google Play" className="w-7 h-7" />
// //               <span className="text-[20px] font-medium font-['Poppins'] text-white">
// //                 Play Store
// //               </span>

// //               <span className="absolute inset-0 rounded-[22px] bg-gradient-to-r from-[#E6C77B]/30 to-[#6E63FF]/30 opacity-0 group-hover:opacity-100 blur-xl transition" />
// //             </motion.a>

// //           </div>
// //         </motion.div>

// //       </div>
// //     </section>
// //   );
// // };

// // export default GetApp;

















// import React from "react";
// import { motion } from "framer-motion";
// import phoneImage from "../assets/newScreen.png";
// import googleLogo from "../assets/googlelogo.png";
// import { FaApple } from "react-icons/fa";

// const GetApp = () => {
//   return (
//     <section className="relative overflow-hidden bg-gradient-to-b from-[#F8F7F4] via-white to-[#FAFAFA]">

//       {/* Ambient luxury glows */}
//       <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-[#E6C77B]/30 rounded-full blur-[160px]" />
//       <div className="absolute top-1/3 -right-40 w-[500px] h-[500px] bg-[#6E63FF]/20 rounded-full blur-[160px]" />

//       {/* Content */}
//       <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 py-24 md:py-36 flex flex-col md:flex-row items-center gap-20">

//         {/* Phone */}
//         <motion.div
//           initial={{ opacity: 0, y: 80 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1.1, ease: "easeOut" }}
//           viewport={{ once: true }}
//           className="md:w-1/2 flex justify-center md:justify-end relative"
//         >
//           {/* Halo */}
//           <div className="absolute -inset-12 bg-gradient-to-tr from-[#E6C77B]/40 to-[#6E63FF]/30 rounded-full blur-[140px]" />

//           <motion.img
//             src={phoneImage}
//             alt="Jurident App"
//             className="relative w-[170px] md:w-[250px] lg:w-[300px] drop-shadow-[0_40px_80px_rgba(0,0,0,0.25)]"
//             animate={{ y: [0, -18, 0], rotate: [0, 1, 0] }}
//             transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
//           />
//         </motion.div>

//         {/* Text */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.1 }}
//           viewport={{ once: true }}
//           className="md:w-1/2 text-center md:text-left"
//         >
//           {/* Eyebrow */}
//           <p className="text-xs tracking-[0.35em] uppercase text-[#B58B2A] mb-6 font-medium">
//             Jurident Mobile App
//           </p>

//           {/* Heading */}
//           <h2 className="text-4xl sm:text-5xl md:text-[56px] leading-tight md:leading-[72px] font-semibold text-gray-900">
//             Your Legal Partner
//             <br />
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#B58B2A] via-[#E6C77B] to-[#6E63FF]">
//               Anytime. Anywhere.
//             </span>
//           </h2>

//           {/* Subtext */}
//           <p className="mt-6 text-lg md:text-[22px] text-gray-600 max-w-xl leading-relaxed">
//             Built for modern legal professionals who value
//             <span className="font-semibold text-gray-900"> precision</span>,
//             <span className="font-semibold text-gray-900"> security</span>, and
//             <span className="font-semibold text-gray-900"> elegance</span>.
//           </p>

//           {/* Buttons */}
//           <div className="flex justify-center md:justify-start gap-6 mt-12 flex-wrap">

//             {/* App Store */}
//             <motion.a
//               whileHover={{ y: -4, scale: 1.05 }}
//               whileTap={{ scale: 0.96 }}
//               href="https://apps.apple.com/in/app/jurident/id6475091173"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="relative inline-flex items-center gap-3 px-8 py-3 rounded-2xl
//               bg-white/70 backdrop-blur-xl border border-black/10
//               shadow-[0_20px_40px_rgba(0,0,0,0.15)]
//               hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//               transition-all"
//             >
//               <FaApple className="w-6 h-6 text-gray-900" />
//               <span className="text-lg font-medium text-gray-900">
//                 App Store
//               </span>
//             </motion.a>

//             {/* Play Store */}
//             <motion.a
//               whileHover={{ y: -4, scale: 1.05 }}
//               whileTap={{ scale: 0.96 }}
//               href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="relative inline-flex items-center gap-3 px-8 py-3 rounded-2xl
//               bg-white/70 backdrop-blur-xl border border-black/10
//               shadow-[0_20px_40px_rgba(0,0,0,0.15)]
//               hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//               transition-all"
//             >
//               <img src={googleLogo} alt="Google Play" className="w-6 h-6" />
//               <span className="text-lg font-medium text-gray-900">
//                 Play Store
//               </span>
//             </motion.a>

//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default GetApp;













// import React from "react";
// import { motion } from "framer-motion";
// import phoneImage from "../assets/newScreen.png";
// import googleLogo from "../assets/googlelogo.png";
// import { FaApple } from "react-icons/fa";

// const GetApp = () => {
//   return (
//     <section className="relative overflow-hidden bg-gradient-to-b from-[#F8F7F4] via-white to-[#FAFAFA]">

//       {/* Ambient light glows */}
//       <div className="absolute -top-40 -left-40 w-[480px] h-[480px] bg-[#E6C77B]/30 rounded-full blur-[160px]" />
//       <div className="absolute top-1/3 -right-40 w-[480px] h-[480px] bg-[#6E63FF]/20 rounded-full blur-[160px]" />

//       {/* Content */}
//       <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 py-24 md:py-36 flex flex-col md:flex-row items-center gap-20">

//         {/* Phone Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 60 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, ease: "easeOut" }}
//           viewport={{ once: true }}
//           className="md:w-1/2 flex justify-center md:justify-end relative"
//         >
//           {/* Soft halo */}
//           <div className="absolute -inset-8 bg-gradient-to-tr from-[#E6C77B]/30 to-[#6E63FF]/25 rounded-full blur-[110px]" />

//           <motion.img
//             src={phoneImage}
//             alt="Jurident Mobile App"
//             className="relative 
//               w-[150px] 
//               sm:w-[170px] 
//               md:w-[200px] 
//               lg:w-[230px]
//               drop-shadow-[0_25px_50px_rgba(0,0,0,0.18)]"
//             animate={{ y: [0, -10, 0] }}
//             transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
//           />
//         </motion.div>

//         {/* Text Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1, delay: 0.1 }}
//           viewport={{ once: true }}
//           className="md:w-1/2 text-center md:text-left"
//         >
//           {/* Eyebrow */}
//           <p className="text-xs tracking-[0.35em] uppercase text-[#B58B2A] mb-6 font-medium">
//             Jurident Mobile App
//           </p>

//           {/* Heading */}
//           <h2 className="text-4xl sm:text-5xl md:text-[56px] leading-tight md:leading-[72px] font-semibold text-gray-900">
//             Your Legal Partner,
//             <br />
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#B58B2A] via-[#E6C77B] to-[#6E63FF]">
//               Anytime. Anywhere.
//             </span>
//           </h2>

//           {/* Description */}
//           <p className="mt-6 text-lg md:text-[22px] text-gray-600 max-w-xl leading-relaxed">
//             Built for modern legal professionals who value
//             <span className="font-semibold text-gray-900"> precision</span>,
//             <span className="font-semibold text-gray-900"> security</span>, and
//             <span className="font-semibold text-gray-900"> elegance</span>.
//           </p>

//           {/* CTA Buttons */}
//           <div className="flex justify-center md:justify-start gap-6 mt-12 flex-wrap">

//             {/* App Store */}
//             <motion.a
//               whileHover={{ y: -4, scale: 1.05 }}
//               whileTap={{ scale: 0.96 }}
//               href="https://apps.apple.com/in/app/jurident/id6475091173"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="
//                 inline-flex items-center gap-3 px-8 py-3 rounded-2xl
//                 bg-white/80 backdrop-blur-xl
//                 border border-black/10
//                 shadow-[0_20px_40px_rgba(0,0,0,0.15)]
//                 hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//                 transition-all
//               "
//             >
//               <FaApple className="w-6 h-6 text-gray-900" />
//               <span className="text-lg font-medium text-gray-900">
//                 App Store
//               </span>
//             </motion.a>

//             {/* Play Store */}
//             <motion.a
//               whileHover={{ y: -4, scale: 1.05 }}
//               whileTap={{ scale: 0.96 }}
//               href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="
//                 inline-flex items-center gap-3 px-8 py-3 rounded-2xl
//                 bg-white/80 backdrop-blur-xl
//                 border border-black/10
//                 shadow-[0_20px_40px_rgba(0,0,0,0.15)]
//                 hover:shadow-[0_30px_60px_rgba(0,0,0,0.2)]
//                 transition-all
//               "
//             >
//               <img src={googleLogo} alt="Google Play" className="w-6 h-6" />
//               <span className="text-lg font-medium text-gray-900">
//                 Play Store
//               </span>
//             </motion.a>

//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default GetApp;









import React from "react";
import { motion } from "framer-motion";
import phoneImage from "../assets/newScreen.png";
import googleLogo from "../assets/googlelogo.png";
import { FaApple } from "react-icons/fa";

const GetApp = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#F8F7F4] via-white to-[#FAFAFA]">
      
      {/* Ambient light glows */}
      <div className="absolute -top-40 -left-40 w-[480px] h-[480px] bg-[#E6C77B]/30 rounded-full blur-[160px]" />
      <div className="absolute top-1/3 -right-40 w-[480px] h-[480px] bg-[#6E63FF]/20 rounded-full blur-[160px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 py-24 md:py-36 flex flex-col md:flex-row items-center gap-20">

        {/* Phone */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="md:w-1/2 flex justify-center md:justify-end relative"
        >
          <div className="absolute -inset-8 bg-gradient-to-tr from-[#E6C77B]/30 to-[#6E63FF]/25 rounded-full blur-[110px]" />

          <motion.div
            className="relative w-[150px] sm:w-[170px] md:w-[200px] lg:w-[230px] drop-shadow-[0_25px_50px_rgba(0,0,0,0.18)]"
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          >
            {/* SCREEN */}
            <div
              className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden"
              style={{ borderRadius: "13% / 6.2%" }}
            >
              <img
                src={phoneImage}
                alt="Jurident Mobile App"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* FRAME */}
            <img src="/codewayphone.png" className="relative z-10 w-full" alt="" />
          </motion.div>
        </motion.div>

        {/* Text */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.1 }}
          viewport={{ once: true }}
          className="md:w-1/2 text-center md:text-left"
        >
          <p className="text-xs tracking-[0.35em] uppercase text-[#B58B2A] mb-6 font-medium">
            Jurident Mobile App
          </p>

          <h2 className="text-4xl sm:text-5xl md:text-[56px] leading-tight md:leading-[72px] font-semibold text-gray-900">
            Your Legal Partner,
            <br />
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#B58B2A] via-[#E6C77B] to-[#6E63FF]">
              Anytime. Anywhere.
            </span>
          </h2>

          <p className="mt-6 text-lg md:text-[22px] text-gray-600 max-w-xl leading-relaxed">
            Built for modern legal professionals who value{" "}
            <span className="font-semibold text-gray-900">precision</span>,{" "}
            <span className="font-semibold text-gray-900">security</span>, and{" "}
            <span className="font-semibold text-gray-900">elegance</span>.
          </p>

          <div className="flex justify-center md:justify-start gap-6 mt-12 flex-wrap">
            <motion.a
              whileHover={{ y: -4, scale: 1.05 }}
              whileTap={{ scale: 0.96 }}
              href="https://apps.apple.com/in/app/jurident/id6475091173"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-3 rounded-2xl bg-white/80 backdrop-blur-xl border border-black/10 shadow-[0_20px_40px_rgba(0,0,0,0.15)]"
            >
              <FaApple className="w-6 h-6" />
              <span className="text-lg font-medium">App Store</span>
            </motion.a>

            <motion.a
              whileHover={{ y: -4, scale: 1.05 }}
              whileTap={{ scale: 0.96 }}
              href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-3 rounded-2xl bg-white/80 backdrop-blur-xl border border-black/10 shadow-[0_20px_40px_rgba(0,0,0,0.15)]"
            >
              <img src={googleLogo} alt="Google Play" className="w-6 h-6" />
              <span className="text-lg font-medium">Play Store</span>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GetApp;